module.exports = __webpack_public_path__ + "stylesheets/both-landings-common_58be9c6cb395ec648028f4e4c7666f98.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/both-landings-common.less
// module id = vzSK
// module chunks = 153